export class GetTableSnapshotsResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "snapshots",
            "baseName": "snapshots",
            "type": "Array<IcebergSnapshotEntry>",
            "format": ""
        },
        {
            "name": "totalSnapshotCount",
            "baseName": "totalSnapshotCount",
            "type": "number",
            "format": ""
        },
        {
            "name": "truncated",
            "baseName": "truncated",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "currentSnapshotId",
            "baseName": "currentSnapshotId",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GetTableSnapshotsResponse.attributeTypeMap;
    }
    constructor() {
    }
}
